import {
    subscriptionCheckoutRedirectSchema,
    subscriptionCheckoutViewSchema,
    type SubscriptionCheckoutRedirect,
    type SubscriptionCheckoutView,
} from '@houzy/schemas/partner-management/partner-subscription-management';
import { queryOptions, useMutation, type UseMutationResult, type UseSuspenseQueryOptions } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { isSupportedLanguage } from '../../../i18n';
import { apiRequest } from '../../../lib/api';
import { partnerCockpitApiPath } from '../../../lib/config';

const path = (token: string, suffix = ''): string =>
    partnerCockpitApiPath(`subscription-checkout/${encodeURIComponent(token)}${suffix}`);

export function checkoutQueryOptions(
    token: string,
): UseSuspenseQueryOptions<SubscriptionCheckoutView, Error, SubscriptionCheckoutView, string[]> {
    return queryOptions({
        queryKey: ['subscription-checkout', token],
        queryFn: ({ signal }): Promise<SubscriptionCheckoutView> =>
            apiRequest(path(token), { responseSchema: subscriptionCheckoutViewSchema, signal }),
    });
}

export function useConfirmCheckout(token: string): UseMutationResult<SubscriptionCheckoutRedirect, Error, void> {
    const { i18n } = useTranslation();

    return useMutation({
        mutationFn: (): Promise<SubscriptionCheckoutRedirect> =>
            apiRequest(path(token, '/confirm'), {
                method: 'POST',
                body: {
                    termsAccepted: true,
                    ...(isSupportedLanguage(i18n.language) ? { language: i18n.language } : {}),
                },
                responseSchema: subscriptionCheckoutRedirectSchema,
            }),
    });
}
